"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.adviceTypes = exports.adviceThemes = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdReact = _interopRequireDefault(require("@bit/gerenciatd.react.icon"));

var _gerenciatdReact2 = _interopRequireDefault(require("@bit/gerenciatd.react.icon-library"));

require("@bit/gerenciatd.react.store-scss");

require("./Advice.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var adviceThemes = {
  INFO: {
    class: 'info',
    defaultIcon: _gerenciatdReact2.default.circularinformacion,
    title: 'información'
  },
  ERROR: {
    class: 'error',
    defaultIcon: _gerenciatdReact2.default.alerta,
    title: 'alerta'
  },
  OK: {
    class: 'ok',
    defaultIcon: _gerenciatdReact2.default.circularok,
    title: 'ok'
  },
  OFFER: {
    class: 'offer',
    defaultIcon: _gerenciatdReact2.default.circularfavoritos,
    title: 'oferta'
  }
};
exports.adviceThemes = adviceThemes;
var adviceTypes = {
  SOLID: 'solid',
  SOFT: 'soft'
};
/**
 * Stateless component to draw an advice
 * @param {object} theme Theme object from adviceThemes structure.
 * @param {string} type type string from adviceTypes structure
 * @param {JSX} children Children rendered.
 * @param {boolean} visible true: shows advice, false: hides advice.
 * @param {string} iconClass Icon to show, if no icon provided, advice render defaultIcon for theme provided.
 * @param {string} title Main title of advice.
 * @param {string} wrapperClass class to override styling of component
 * @returns {JSX} Component JSX.
 */

exports.adviceTypes = adviceTypes;

var Advice =
/*#__PURE__*/
function (_Component) {
  _inherits(Advice, _Component);

  function Advice(props) {
    var _this;

    _classCallCheck(this, Advice);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Advice).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "hideAdvice", function () {
      _this.setState({
        noVisible: true
      });
    });

    var noVisible = props.noVisible;
    _this.state = {
      noVisible: noVisible
    };
    return _this;
  }

  _createClass(Advice, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (nextProps.noVisible !== this.props.noVisible) {
        var noVisible = this.props.noVisible;
        this.setState = {
          noVisible: noVisible
        };
        return false;
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          type = _this$props.type,
          children = _this$props.children,
          iconClass = _this$props.iconClass,
          title = _this$props.title,
          wrapperClass = _this$props.wrapperClass;
      var noVisible = this.state.noVisible;

      if (noVisible) {
        return null;
      }

      var classIcon = iconClass;

      if (!classIcon) {
        classIcon = theme.defaultIcon;
      }

      return _react.default.createElement("div", {
        className: "advice advice--".concat(theme.class, " advice--").concat(type, " ").concat(wrapperClass)
      }, _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
        className: "adviceIcon"
      }, _react.default.createElement(_gerenciatdReact.default, {
        title: theme.title,
        classIcon: classIcon
      })), _react.default.createElement("span", {
        className: "adviceLabel"
      }, title && _react.default.createElement("span", {
        className: "adviceLabelTitle"
      }, title), children && _react.default.createElement("span", {
        className: "adviceLabelParagraph"
      }, children)), _react.default.createElement(_gerenciatdReact.default, {
        title: "ocultar aviso",
        classIcon: _gerenciatdReact2.default.x,
        onClick: this.hideAdvice,
        wrapperClass: "hideIcon"
      })));
    }
  }]);

  return Advice;
}(_react.Component);

Advice.propTypes = {
  theme: _propTypes.default.object,
  type: _propTypes.default.string,
  children: _propTypes.default.node,
  noVisible: _propTypes.default.bool,
  iconClass: _propTypes.default.string,
  wrapperClass: _propTypes.default.string
};
Advice.defaultProps = {
  theme: adviceThemes.INFO,
  type: adviceTypes.SOFT,
  children: null,
  noVisible: false,
  iconClass: '',
  wrapperClass: ''
};
var _default = Advice;
exports.default = _default;

//# sourceMappingURL=index.js.map